'use strict'

// The freq pill historically showed the property's static frequencyCode (e.g.
// BW_B). On the anchored board a single property can have several distinct
// services on different dates (a Monthly visit AND a Biweekly visit), so a
// monthly occurrence wearing "BW_B" reads as a duplicated bi-weekly. When the
// occurrence carries its own service name, infer that service's cadence so each
// stop shows its real frequency; otherwise fall back to the property code.
const SERVICE_NAME_FREQUENCY_PILL = [
  [/\bmonthly\b/i, 'M'],
  [/\b(bi-?weekly|every other week)\b/i, 'BW'],
  [/\bweekly\b/i, 'W'],
  [/\bquarterly\b/i, 'Q'],
  [/\b(semi-?annual|bi-?annual)\b/i, 'SA'],
  [/\bannual(ly)?\b/i, 'A']
]

export const inferFrequencyPillFromServiceName = (serviceName) => {
  const text = String(serviceName || '')
  if (!text) return null
  for (const [pattern, code] of SERVICE_NAME_FREQUENCY_PILL) {
    if (pattern.test(text)) return code
  }
  return null
}

// Per-occurrence frequency label for the card pill. Prefers the service-name
// cadence (anchored work-ticket stops), then the property frequencyCode.
export const getStopFrequencyPill = (stop = {}) => {
  return inferFrequencyPillFromServiceName(stop.serviceName) || stop.frequencyCode || null
}
